import { bodyBgHeight } from './BodyBgStore.js';

export const updateBodyBgHeight = (value) => bodyBgHeight.update(oldValue => value);
